import './back-to-top.scss';
export default (() => {
  // Check if the element with class 'back-to-top-outer' exists
  const backToTop = document.querySelector('.back-to-top-outer');
  if (backToTop) {
    // Listen to the window scroll event
    window.addEventListener('scroll', function () {
      // Get the scroll position
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // If scrolled more than 200px, add the 'visible' class
      if (scrollTop > 200) {
        backToTop.classList.add('visible');
      } else {
        // Otherwise, remove the 'visible' class
        backToTop.classList.remove('visible');
      }
    });
  }
});